<template>
    <div class="recaptcha-container">
      <div :id="idRecaptcha" :ref="idRecaptcha"></div>
      <span
        v-if="recaptchaError"
        style="font-size: 14px; margin-top: 10px; color: red"
      >
        Per favore spunta il controllo reCaptcha
      </span>
    </div>
  </template>
  
  <script>
  import intl from "./intl/intl";
  
  export default {
    name: "recaptchaContainer",
    components: {},
    props: {
      idRecaptcha: {
        type: String,
        default: "recaptcha",
      },
      siteKey: {
        type: String,
        default: process.env.VUE_APP_RECAPTCHA_SITEKEY,
      },
      recaptchaCallback: {
        type: Function,
        default: (value) => {
        
          return;
        },
      },
    },
  
    created() {},
    mounted() {
      this.recaptchaWidgetId = grecaptcha.render(this.$refs[this.idRecaptcha], {
        sitekey: this.siteKey,
        callback: this.callback,
      });
    },
  
    data: function () {
      return {
        intl: intl,
        recaptchaError: false,
        recaptchaWidgetId: null,
      };
    },
    methods: {
      callback(value) {
        if(value){
            this.recaptchaError = false
        }
        if(this.recaptchaCallback){
          this.recaptchaCallback(value)
        }
      },
      executeRecaptcha() {
        const recaptchaResponse = grecaptcha.getResponse(this.recaptchaWidgetId);
        if (recaptchaResponse.length === 0) {
          this.recaptchaError = true
        }else{
          this.recaptchaError = false
        }
        return recaptchaResponse
      },
    },
    computed: {},
    unmounted() {},
  };
  </script>